import { createContext, useContext } from "react";

/**
 * True while the analytics data is being refreshed, or before the page knows whether it is: the
 * widgets then show their loading state and fetch nothing (the data is rewritten chunk by chunk).
 */
export const AnalyticsRefreshingContext = createContext(false);

export const useIsAnalyticsRefreshing = () => useContext(AnalyticsRefreshingContext);
